import { Login, Home, NewCase, NewPatient, Evaluations, PendingReports, NewReport, ABM as Abm } from './views'
import { Provider as ReduxProvider, useSelector } from 'react-redux'
import Pdf from './components/Pdf'
import { Layout } from './components'
import { useValidateToken } from './hooks/useValidateToken'
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'
import store from './redux/store'
import { PatientReport } from './views/PatientReport'
import InstitutionsManagement from './views/AdminManagement/InstitutionsManagement'
import TechniciansManagement from './views/AdminManagement/TechniciansManagement'
import OphthalmologistsManagement from './views/AdminManagement/OphthalmologistsManagement'
import AdminsManagement from './views/AdminManagement/AdminsManagement'
import InstitutionAdminsManagement from './views/AdminManagement/InstitutionAdminsManagement'
import MyInstitutionNodes from './views/AdminManagement/MyInstitutionNodes'

const userRolePaths = {
  technical: ['/home', '/new-case', '/new-patient', '/evaluations'],
  patient: ['/home', '/new-report', '/report', '/evaluations', '/pdf'],
  ophthalmologist: ['/home', '/pending-reports', '/new-report', '/evaluations', '/report'],
  admin: ['/home', '/admin/institutions', '/admin/technicians', '/admin/ophthalmologists', '/admin/admins', '/admin/institution-admins'],
  admin_institucion: ['/home', '/admin/technicians', '/admin/ophthalmologists', '/admin/nodes']
}

function userHasAuthorization (path) {
  const { user } = useSelector(state => state)
  const { role } = user
  return userRolePaths[role].includes(path)
}

function PrivateRoute ({ children, path }) {
  const LIST_OF_PATHS = ['/home', '/new-case', '/new-patient', '/evaluations', '/pending-reports', '/new-report', '/report', '/abm', '/pdf', '/login', '/admin/institutions', '/admin/technicians', '/admin/ophthalmologists', '/admin/admins', '/admin/institution-admins', '/admin/nodes']

  const { validate } = useValidateToken()

  const { isLogged } = validate()

  const isPathValid = LIST_OF_PATHS.includes(path)

  if (!isLogged && isPathValid) return <Redirect to='/login' />
  else if (isLogged && path === '/login') return <Redirect to='/home' />
  else if (isLogged && !isPathValid) return <Redirect to='/home' />
  else if (isLogged && !userHasAuthorization(path)) return <Redirect to='/home' />
  else return <Route path={path}>{children}</Route>
}

// import { LoadingScreen } from './components/LoadingScreen'

function App () {
  return (
    <ReduxProvider store={store}>
      <BrowserRouter>
        <Switch>
          <Route path='/login'>
            <Login />
          </Route>
          <Layout>
            <PrivateRoute path='/home'>
              <Home />
            </PrivateRoute>
            <PrivateRoute path='/new-case'>
              <NewCase />
            </PrivateRoute>
            <PrivateRoute path='/evaluations'>
              <Evaluations />
            </PrivateRoute>
            <PrivateRoute path='/new-report'>
              <NewReport />
            </PrivateRoute>
            <PrivateRoute path='/pending-reports'>
              <PendingReports />
            </PrivateRoute>
            <PrivateRoute path='/report'>
              <PatientReport />
            </PrivateRoute>
            <PrivateRoute path='/abm'>
              <Abm />
            </PrivateRoute>
            <PrivateRoute path='/pdf'>
              <Pdf />
            </PrivateRoute>
            <PrivateRoute path='/new-patient'>
              <NewPatient />
            </PrivateRoute>
            <PrivateRoute path='/admin/institutions'>
              <InstitutionsManagement />
            </PrivateRoute>
            <PrivateRoute path='/admin/technicians'>
              <TechniciansManagement />
            </PrivateRoute>
            <PrivateRoute path='/admin/ophthalmologists'>
              <OphthalmologistsManagement />
            </PrivateRoute>
            <PrivateRoute path='/admin/admins'>
              <AdminsManagement />
            </PrivateRoute>
            <PrivateRoute path='/admin/institution-admins'>
              <InstitutionAdminsManagement />
            </PrivateRoute>
            <PrivateRoute path='/admin/nodes'>
              <MyInstitutionNodes />
            </PrivateRoute>
            <PrivateRoute />
          </Layout>
        </Switch>
      </BrowserRouter>
    </ReduxProvider>
  )
}

export default App
